import type { FC } from "react";
import { PusherProvider } from "./PusherProvider";
import { Redirect, Route, type RouteProps } from "react-router-dom";
import { useStoreId } from "hooks/useStoreId";

// import debug from 'debug'
// const log = debug('@ikew:components:AuthenticatedApp')

export const AuthenticatedApp: FC<
	{
		component: any;
	} & RouteProps
> = ({ component: Component, ...rest }) => {
	const { storeId } = useStoreId();

	return (
		<Route
			{...rest}
			render={(props: RouteProps) =>
				storeId ? (
					<PusherProvider>
						<Component {...props} />
					</PusherProvider>
				) : (
					<Redirect push to="/set-store" />
				)
			}
		/>
	);
};
